import { render, staticRenderFns } from "./WsRequestExamsTableDetails.vue?vue&type=template&id=7dd44bba"
import script from "./WsRequestExamsTableDetails.vue?vue&type=script&lang=js"
export * from "./WsRequestExamsTableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports